export let type = [
  "EVCS", //
  "EESS", //
  "ESCB", //
];

export let powerType = [
  "AC", //
  "DC", //
];
export let plugType = [
  "CHAdeMO", //
  "CCS", //
  "TeslaType2", //
  "Type2", //
  "Type1", //
  "Commando", //
  "3Pin", //
];

export let filters = {
  plugType: [
    {
      name: plugType[0], //
      value: false, //
      icon: "mdi-ev-plug-chademo", //
    },
    {
      name: plugType[1], //
      value: false, //
      icon: "mdi-ev-plug-ccs2", //
    },
    {
      name: plugType[2], //
      value: false, //
      icon: "mdi-ev-plug-tesla", //
    },
    {
      name: plugType[3], //
      value: false, //
      icon: "mdi-ev-plug-type2", //
    },
    {
      name: plugType[4], //
      value: false, //
      icon: "mdi-ev-plug-type1", //
    },
    {
      name: plugType[5], //
      value: false, //
      icon: "mdi-power-socket-fr", //
    },
    {
      name: plugType[6], //
      value: false, //
      icon: "mdi-power-socket-uk", //
    },
  ],
  powerType: [
    {
      name: powerType[0], //
      value: false, //
      icon: "mdi-current-ac", //
    },
    {
      name: powerType[1], //
      value: false, //
      icon: "mdi-current-dc", //
    },
  ],
  minPower: [
    {
      name: "kW", //
      value: 0, //
      icon: "mdi-power-plug", //
    },
  ],
  type: [
    {
      name: type[0], //
      value: false, //
      icon: "mdi-ev-station", //
    },
    {
      name: type[1], //
      value: false, //
      icon: "mdi-solar-panel-large", //
    },
    {
      name: type[2], //
      value: false, //
      icon: "mdi-cloud-sync", //
    },
  ],
};
